import type { QueryKey, UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import type Maybe from 'true-myth/maybe';

import { ApplicationContext } from '~/shared/context/context';
import type { SkillShort } from '~/shared/data-contract/skill';
import { skillShortSchema } from '~/shared/data-contract/skill';
import type { Pathname } from '~/shared/http-fetcher/http-fetcher';

export type UseTalentDirectorySkillSearchResult = UseQueryResult<readonly SkillShort[]>;

export const useTalentDirectorySkillSearch = (options: {
    readonly enabled: boolean;
    readonly searchTerm: Maybe<string>;
}): UseTalentDirectorySkillSearchResult => {
    const { enabled, searchTerm } = options;
    const { applicationState, validatingCobrainerApiFetcher } = useContext(ApplicationContext);
    const pathname: Pathname = `/global/directory/skills/search`;
    const queryKey: QueryKey = [pathname, 'get', applicationState.language.code, searchTerm];

    return useQuery({
        enabled,
        queryFn: async () => {
            const result = await validatingCobrainerApiFetcher.get(skillShortSchema.array(), {
                pathname,
                requestOptions: {
                    searchParams: {
                        limit: 20,
                        searchTerm: searchTerm.unwrapOr(''),
                    },
                },
            });

            if (result.isOk) {
                return result.value;
            }

            throw result.error;
        },
        queryKey,
    });
};
